import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Hidden,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { toEnglishDate, toSpanishDate } from "../../../helpers/dateFormat";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { selectOpportunity } from "../../../store/opportunity/opportunitySlice";
import { numberFormat } from "../../../helpers/numberFormat";

export const OpportunitiesSmallTable = ({ rows }) => {
  const { t } = useTranslation("global");
  const date = new Date();
  const options = { day: "2-digit", month: "2-digit", year: "numeric" };
  const actualDate = date.toLocaleDateString("es-ES", options);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search); 
  const isInApp = searchParams.get('target') === 'app';

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onReserveClick = (e) => {
    navigate(`/reservation`);
    dispatch(selectOpportunity({...e, isInApp}));
  };

  return rows.map((opp) => {
    return (
      <Hidden mdUp key={opp.id}>
        <Accordion>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Stack width="100%">
              <Stack
                direction="row"
                flexWrap="wrap"
                md={{ justifyContent: "space-between" }}
              >
                <Typography variant="body2" color="primary" marginRight="10px">
                  {t("opportunities.startup")}:{" "}
                </Typography>
                <Typography variant="body2" color="secondary">
                  {opp.startupAlias}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                flexWrap="wrap"
                md={{ justifyContent: "space-between" }}
              >
                <Typography variant="body2" color="primary" marginRight="10px">
                  {t("opportunities.roundNumber")}:
                </Typography>
                <Typography variant="body2" color="secondary">
                  {opp.roundNumber}
                </Typography>
              </Stack>
              <Stack
                direction="row"
                flexWrap="wrap"
                md={{ justifyContent: "space-between" }}
              >
                <Typography variant="body2" color="primary" marginRight="10px">
                  {t("opportunities.myStatus")}:
                </Typography>
                <Typography
                  variant="body2"
                  color={
                    opp.myStatus === "Reserva realizada" ||
                    opp.myStatus === "Reservation made"
                      ? "success.main"
                      : "secondary"
                  }
                >
                  {opp.myStatus}
                </Typography>
              </Stack>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Stack
              width="100%"
              direction="row"
              flexWrap="wrap"
              gap={1}
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" flexWrap="wrap" alignItems="center">
                <Typography variant="body2" color="primary" marginRight="10px">
                  {t("opportunities.url")}:
                </Typography>
                <a
                  href={opp.url}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#EA7F22" }}
                >
                  {t("link.link")}
                </a>
              </Stack>
              <Stack direction="row" flexWrap="wrap" alignItems="center">
                <Typography variant="body2" color="primary" marginRight="10px">
                  {t("opportunities.doc")}:
                </Typography>
                <a
                  href={opp.urlVideo}
                  target="_blank"
                  rel="noreferrer"
                  style={{ color: "#EA7F22" }}
                >
                  {t("link.link")}
                </a>
              </Stack>
              {opp.reservationDeadline >= toEnglishDate(actualDate) ? (
                <>
                  <Stack direction="row" flexWrap="wrap" minWidth="150px">
                    <Typography
                      variant="body2"
                      color="primary"
                      marginRight="10px"
                    >
                      {t("opportunities.reservationDeadline")}:
                    </Typography>
                    <Typography variant="body2" color="secondary">
                      {toSpanishDate(opp.reservationDeadline)}
                    </Typography>
                  </Stack>
                  {(opp.myStatus === "Sin respuesta" ||
                    opp.myStatus === "Pending answer") && (
                    <>
                      <Button
                        onClick={() => onReserveClick(opp)}
                        fullWidth
                        variant="outlined"
                        color="secondary"
                      >
                        {t("opportunities.answer")}
                      </Button>
                    </>
                  )}
                  {(opp.myStatus === "Reserva realizada" ||
                    opp.myStatus === "Reservation made") && (
                    <>
                      <Stack direction="row" flexWrap="wrap" minWidth="140px">
                        <Typography
                          color="primary"
                          variant="body2"
                          marginRight="10px"
                        >
                          {t("opportunities.amount")}:{" "}
                        </Typography>
                        <Typography color="secondary" variant="body2">
                          {numberFormat(opp.amount)}
                        </Typography>
                      </Stack>
                      <Button
                        onClick={() => onReserveClick(opp)}
                        variant="outlined"
                        fullWidth
                        color="secondary"
                      >
                        {t("opportunities.edit")}
                      </Button>
                    </>
                  )}
                  {(opp.myStatus === "No reserva" ||
                    opp.myStatus === "No reservation") && (
                    <>
                      <Button
                        onClick={() => onReserveClick(opp)}
                        fullWidth
                        variant="outlined"
                        color="secondary"
                      >
                        {t("opportunities.reserve")}
                      </Button>
                    </>
                  )}
                </>
              ) : (
                <>
                  {opp.amount !== 0 &&
                    opp.myStatus !== "Sin respuesta" &&
                    opp.myStatus === "Pending answer" && (
                      <Stack
                        direction="row"
                        flexWrap="wrap"
                        md={{ justifyContent: "space-between" }}
                      >
                        <Typography
                          color="primary"
                          variant="body2"
                          marginRight="10px"
                        >
                          {t("opportunities.amount")}:{" "}
                        </Typography>
                        <Typography color="secondary" variant="body2">
                          {numberFormat(opp.amount)}
                        </Typography>
                      </Stack>
                    )}
                  <Button
                    fullWidth
                    disabled
                    variant="outlined"
                    color="secondary"
                  >
                    {t("opportunities.close")}
                  </Button>
                </>
              )}
            </Stack>
          </AccordionDetails>
        </Accordion>
      </Hidden>
    );
  });
};
